import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  UserCog,
  Share2,
  LogOut,
  ClipboardList,
  CalendarDays,
} from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const items = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/candidates", label: "Candidates", icon: Users, testid: "nav-candidates" },
    { to: "/calendar", label: "Calendar", icon: CalendarDays, testid: "nav-calendar" },
    { to: "/share", label: "Share Link", icon: Share2, testid: "nav-share" },
  ];
  if (user?.role === "admin") {
    items.push({ to: "/team", label: "Team", icon: UserCog, testid: "nav-team" });
  }

  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex md:flex-col w-64 shrink-0 bg-ink-900 text-white min-h-screen sticky top-0"
    >
      <div className="px-5 py-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <Logo size={40} withText dark />
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive
                  ? "bg-brand-700 text-white shadow-sm"
                  : "text-slate-300 hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Icon size={18} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-white/10 px-4 py-4 space-y-3">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-full bg-brand-600 text-white grid place-items-center font-semibold">
            {(user?.name || "U").charAt(0).toUpperCase()}
          </div>
          <div className="leading-tight">
            <div className="text-sm font-medium" data-testid="sidebar-user-name">
              {user?.name}
            </div>
            <div className="text-[11px] text-slate-400 uppercase tracking-wider">
              {user?.role}
            </div>
          </div>
        </div>
        <Button
          data-testid="logout-btn"
          onClick={async () => {
            await logout();
            nav("/login");
          }}
          variant="outline"
          className="w-full bg-transparent border-white/15 text-white hover:bg-white/10 hover:text-white"
        >
          <LogOut size={16} className="mr-2" /> Sign out
        </Button>
      </div>
    </aside>
  );
};

export const MobileTopbar = () => {
  return (
    <header
      className="md:hidden sticky top-0 z-30 bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between"
      data-testid="mobile-topbar"
    >
      <Logo size={36} withText />
    </header>
  );
};
